import { Bindings, BuildClass, Checkbox, ConditionalObject, FormButton, FormButtonSet, HelpIcon, LoadingSpinnerLarge, Textbox, clamp, clearServiceWorkerCache, moment, reactFlyout, timer, trionlineAjax, unsubscribe, } from '../components';
import { $, React } from '../lib';
const ADUR = 200;
let CACHE_CLEARED = false;
const TIMER = null;
let checkOnlineStatusCount = 0;
const resetPassword = () => {
    let url = '/acct/new-password/';
    let email = ($('.txtUser').val() || '');
    if (email.indexOf('@') < 0) {
        email = '';
    }
    if (email !== '') {
        url += `?e=${email}`;
    }
    location.href = url;
};
const RequestAccountFlyout = (props) => (React.createElement("div", { className: "frmRequestAccount" },
    React.createElement("div", { className: "info" }, "Please contact your facility administrator to create an account for you."),
    React.createElement(FormButtonSet, { loading: false, msg: "", tick: false },
        React.createElement(FormButton, { type: "standard", lbl: "Close", onClick: () => {
                props.flyout?.Close();
            } }))));
const checkOnlineStatus = () => {
    checkOnlineStatusHelper(val => {
        if (!val) {
            checkOnlineStatusCount += 1;
            let timeout = 1000 + checkOnlineStatusCount * 500;
            timeout = clamp(timeout, 1000, 15000);
            timer(timeout, checkOnlineStatus);
        }
    });
};
var checkOnlineStatusHelper = cb => {
    trionlineAjax({
        url: '/api/am-i-signed-in/',
        error: () => cb(false),
        success: data => {
            if (data !== 'NO') {
                location.reload();
                cb(true);
                return;
            }
            if (!CACHE_CLEARED) {
                unsubscribe();
                clearServiceWorkerCache();
                CACHE_CLEARED = true;
                return;
            }
            timer(1000, () => {
                cb(false);
            });
        },
    });
};
class LoginForm extends React.Component {
    constructor(props) {
        super(props);
        Bindings(this, [this.signIn]);
        this.state = {
            userID: '',
            pwd: '',
            mfa: '',
            rememberMe: false,
            isLoading: false,
            message: '',
            showingMessage: false,
            showTick: false,
        };
    }
    componentDidMount() {
        checkOnlineStatus();
    }
    render() {
        return (React.createElement("div", { className: "login-page-wrapper fixed-height-content" },
            React.createElement("div", { className: "login-form-wrapper" },
                React.createElement("div", { className: "box-shadow pnLogin noselect" },
                    React.createElement("img", { className: "trionline-logo", src: "/static/img/svg/trionline.svg", alt: "TriOnline" }),
                    this.buildForm(),
                    this.buildResponse())),
            this.buildFooter()));
    }
    buildForm() {
        const buildUsername = (React.createElement("label", { className: "input-row" },
            this.buildIcon('ID / Email', '/static/img/svg/login-email.svg'),
            React.createElement("span", { className: "input-wrapper" },
                React.createElement(Textbox, { id: "username", className: "txtUser", value: this.state.userID, onUpdate: v => {
                        this.setState({ userID: v });
                    }, type: "text", placeholder: "ID / Email" })),
            React.createElement("span", { className: "icon-wrapper help-wrapper" },
                React.createElement(HelpIcon, { title: "You should have received a welcome email to the email address that is linked to your account" }))));
        const buildPassword = (React.createElement("label", { className: "input-row" },
            this.buildIcon('Password', '/static/img/svg/login-password.svg'),
            React.createElement("span", { className: "input-wrapper" },
                React.createElement(Textbox, { value: this.state.pwd, onUpdate: v => {
                        this.setState({ pwd: v });
                    }, id: "password", className: "txtPass", type: "password", placeholder: "Password" })),
            React.createElement("span", { className: "icon-wrapper help-wrapper" },
                React.createElement(HelpIcon, { title: "If you don't know your password or haven't signed in before, click the 'Reset Password' button to create a new one" }))));
        const buildMFA = (React.createElement("label", { className: "mfa" },
            this.buildIcon('MFA', '/static/img/svg/login-mfa.svg'),
            React.createElement("span", { className: "input-wrapper mfa-wrapper" },
                React.createElement(Textbox, { value: this.state.mfa, onUpdate: v => {
                        this.setState({ mfa: v });
                    }, id: "mfacode", className: "txtMFA", type: "text", placeholder: "MFA (Optional)", maxLength: 6 })),
            React.createElement("span", { key: "help-wrapper-mfa", className: "icon-wrapper help-wrapper" },
                React.createElement(HelpIcon, { title: "Only needed if you have multi-factor security enabled for your account. Generally only needed for users who work with sensitive information" }))));
        const buildRememberMe = (React.createElement("label", { className: "persistence" },
            React.createElement("span", { className: "remember-me" },
                React.createElement(Checkbox, { value: this.state.rememberMe, onUpdate: v => {
                        this.setState({ rememberMe: v });
                    }, lbl: "" },
                    React.createElement(React.Fragment, null,
                        "Remember",
                        React.createElement("span", { className: "me" }, " Me")))),
            React.createElement("span", { className: "icon-wrapper help-wrapper" },
                React.createElement(HelpIcon, { title: "If checked, you will stay signed in to TriOnline until you explicitly sign out. For security reasons, do NOT use this on shared devices, since others could access your account" }))));
        const buildSignInButton = (React.createElement("div", { className: "cntr" },
            React.createElement("button", { className: "btnSubmit2 btnSignIn", type: "submit" }, "Sign In")));
        const buildRequestAndReset = (React.createElement("div", { className: "cntr request-reset" },
            React.createElement("a", { href: "#request", onClick: e => {
                    e.preventDefault();
                    reactFlyout('Request Account', [300, 160], React.createElement(RequestAccountFlyout, null));
                    return false;
                } }, "Request Account"),
            React.createElement("a", { href: "#reset", onClick: e => {
                    e.preventDefault();
                    resetPassword();
                    return false;
                } }, "Reset Password")));
        return (React.createElement("form", { className: BuildClass({
                'login-form': true,
                hidden: this.state.showingMessage,
            }), onSubmit: e => {
                e.preventDefault();
                this.signIn();
            } },
            buildUsername,
            buildPassword,
            React.createElement("div", { className: "input-row input-row-mfa" },
                buildMFA,
                buildRememberMe),
            React.createElement("div", { className: "buttons" },
                buildSignInButton,
                buildRequestAndReset)));
    }
    buildIcon(alt, src) {
        return (React.createElement("span", { className: "icon-wrapper" },
            React.createElement("img", { alt: alt, src: src })));
    }
    buildResponse() {
        return (React.createElement("div", { className: BuildClass({
                response: true,
                hidden: !this.state.showingMessage,
            }) },
            ConditionalObject(this.state.isLoading, React.createElement(LoadingSpinnerLarge, null)),
            ConditionalObject(this.state.showTick, React.createElement("img", { alt: "Success!", className: "imgTick", src: "/static/img/svg/tick-large.svg" })),
            ConditionalObject(Boolean(this.state.message), React.createElement("div", { className: "inline_error_msg" }, this.state.message))));
    }
    buildFooter() {
        return (React.createElement("div", { className: "footer-wrapper" },
            React.createElement("div", { className: "box-shadow footer-links" },
                React.createElement("a", { href: "/help/" }, "Help"),
                React.createElement("a", { href: "https://trimicro.com.au/", target: "_blank", rel: "noopener" }, "TriMicro"),
                React.createElement("a", { href: "/privacy/" }, "Privacy"),
                React.createElement("a", { href: "/terms/" }, "Terms"),
                React.createElement("div", { className: "pnCopyright" },
                    React.createElement("span", null, `© Software North ${moment().format('YYYY')}`),
                    React.createElement("span", null, "All Rights Reserved")))));
    }
    signIn() {
        if (!this.state.userID || !this.state.pwd) {
            return;
        }
        this.setState({
            showingMessage: true,
            isLoading: true,
            message: '',
            showTick: false,
        });
        trionlineAjax({
            url: '/login/verify.py',
            method: 'POST',
            data: {
                u: this.state.userID,
                p: this.state.pwd,
                mfa: this.state.mfa,
                persistent: this.state.rememberMe,
            },
            no: msg => {
                timer(() => {
                    throw Error(`Login page error: ${JSON.stringify(msg.responseText)}`);
                });
                this.flashMessage('Unexpected Error');
            },
            yes: (msg) => {
                if (msg.length > 100) {
                    console.log(msg);
                    this.flashMessage('Unexpected Error');
                    return;
                }
                if (msg === 'Successful') {
                    this.showSuccecss();
                    return;
                }
                this.flashMessage(msg);
            },
        });
    }
    flashMessage(msg) {
        this.setState({
            isLoading: false,
            message: msg,
            showingMessage: true,
        });
        timer(ADUR, () => {
            this.setState({
                message: '',
                showingMessage: false,
            });
        });
    }
    showSuccecss() {
        this.setState({
            isLoading: false,
            message: '',
            showTick: true,
        });
        timer(ADUR * 2 + 400, () => {
            const path64 = window.rootData?.UrlParts?.args?.rd;
            const path = path64 ? atob(path64) : '/';
            location.href = path;
        });
    }
}
export const openLoginPage = () => ({
    contentPadding: false,
    theme: 'green',
    transparentBackground: true,
    hideTopNav: true,
    hideSidebar: true,
    content: () => React.createElement(LoginForm, null),
});
//# sourceMappingURL=login-page.js.map